module.exports = __webpack_public_path__ + "img/apple5.bf2cb392.png";